// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"3":"d17abd7f","182":"5e223b7f","453":"b3f78db9","767":"8a1b887e"}[chunkId] + ".chunk.js";
};